<template>
  <div class="tai-xiu-game">
    <tai-xiu-specific-number
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :win-numbers="[
        this.drawResult.n1,
        this.drawResult.n2,
        this.drawResult.n3
      ]"
    />
    <tai-xiu-big-small
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :win-cell-no="
        `o${parseInt(this.drawResult.triple) || parseInt(this.drawResult.bs)}`
      "
    />
    <tai-xiu-odd-even
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :win-cell-no="`o${parseInt(this.drawResult.oe)}`"
    />
    <tai-xiu-specific-total
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :win-total="
        `o${100 + this.drawResult.n1 + this.drawResult.n2 + this.drawResult.n3}`
      "
    />
    <div
      ref="tai-xiu-disallow-betting-section"
      class="tai-xiu-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row class="tai-xiu-disallow-betting" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
    <div
      ref="tai-xiu-stop-animation-section"
      class="tai-xiu-stop-animation-section"
      :class="{ show: displayStopAnimationSection }"
    >
      <Row class="tai-xiu-stop-animation" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
    <div
      ref="animation-section"
      class="tai-xiu-animation-section"
      :class="{ hide: displayStopAnimationSection }"
    >
      <img
        width="100%"
        height="100%"
        src="../../assets/images/common/blank.gif"
        style="position:absolute; top:0;left:0;right:0;bottom:0;"
      />
      <Row class="tai-xiu-animation-inner">
        <Row class="tai-xiu-animation-container">
          <img class="tai-xiu-animation-img" ref="tai-xiu-animation-img" width="100%" src alt />
          <Row
            ref="animation-result"
            class="tai-xiu-animation-result"
            type="flex"
            justify="center"
            align="middle"
          >
            <Col ref="animation-result-container" class="tai-xiu-animation-result-container">
              <img
                ref="animation-plate"
                class="tai-xiu-animation-result-plate"
                src="../../assets/images/tai-xiu/assets/plate2.png"
                alt
              />
              <img
                ref="animation-tai-xiu-1"
                class="tai-xiu-animation-result-dice tai-xiu-1"
                src="../../assets/images/tai-xiu/assets/dice-1.png"
                alt
              />
              <img
                ref="animation-tai-xiu-2"
                class="tai-xiu-animation-result-dice tai-xiu-2"
                src="../../assets/images/tai-xiu/assets/dice-1.png"
                alt
              />
              <img
                ref="animation-tai-xiu-3"
                class="tai-xiu-animation-result-dice tai-xiu-3"
                src="../../assets/images/tai-xiu/assets/dice-1.png"
                alt
              />
            </Col>

            <Col ref="animation-banner-container" class="tai-xiu-animation-banner-container">
              <Row
                class="tai-xiu-animation-banner-inner"
                type="flex"
                justify="center"
                align="middle"
              >
                <img
                  class="tai-xiu-animation-result-banner-top"
                  src="../../assets/images/tai-xiu/assets/banner-top.png"
                  width="100%"
                  alt
                />
                <Row class="tai-xiu-animation-result-banner-sum" type="flex" justify="center">
                  <Col>
                    <div class="tai-xiu-animation-result-banner-sum-title">{{ $t("general.sum") }}</div>
                    <Row
                      class="tai-xiu-animation-result-banner-sum-total"
                      type="flex"
                      justify="center"
                    >
                      {{
                      this.drawResult.n1 +
                      this.drawResult.n2 +
                      this.drawResult.n3
                      }}
                    </Row>
                  </Col>
                </Row>

                <img
                  class="tai-xiu-animation-result-banner-shine"
                  src="../../assets/images/tai-xiu/assets/banner-shine.png"
                  width="100%"
                  alt
                />
                <img
                  class="tai-xiu-animation-result-banner-bottom"
                  src="../../assets/images/tai-xiu/assets/banner-bottom.png"
                  width="100%"
                  alt
                />
                <Row class="tai-xiu-animation-result-banner-game" type="flex" justify="center">
                  <Col>
                    <div
                      class="tai-xiu-animation-result-banner-game-result"
                    >{{ $t(`${snakeCaseTitle}.o${drawResultBigSmall}`) }}</div>
                  </Col>
                  <Col>
                    <div class="tai-xiu-animation-result-banner-game-result">
                      {{
                      $t(
                      `${snakeCaseTitle}.o${(this.drawResult &&
                      this.drawResult.oe) ||
                      4}`
                      )
                      }}
                    </div>
                  </Col>
                </Row>
              </Row>
            </Col>
          </Row>
        </Row>
        <Row class="tai-xiu-game-animation-next-draw-section" type="flex" justify="center">
          <!-- <a
            class="tai-xiu-game-animation-next-draw"
            @click="nextDrawOnClick"
          >{{ $t("general.next_draw") }}</a>-->
        </Row>
      </Row>
    </div>
  </div>
</template>

<script>
import { snakeCase } from "change-case";
import { random } from "lodash";
import { TweenLite, TimelineLite } from "gsap";
import { Row, Button } from "iview";
import TaiXiuSpecificNumber from "./tai-xiu-game/TaiXiuSpecificNumber";
import TaiXiuBigSmall from "./tai-xiu-game/TaiXiuBigSmall";
import TaiXiuOddEven from "./tai-xiu-game/TaiXiuOddEven";
import TaiXiuSpecificTotal from "./tai-xiu-game/TaiXiuSpecificTotal";
import EventBus from "../../configs/event-bus";

let diceTl = new TimelineLite();
let plateTl = new TimelineLite();

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString"
  ],
  components: {
    TaiXiuSpecificNumber,
    TaiXiuBigSmall,
    TaiXiuOddEven,
    TaiXiuSpecificTotal,
    Row,
    Button
  },
  computed: {
    snakeCaseTitle() {
      return snakeCase(this.game);
    },
    drawResultBigSmall() {
      if (!this.drawResult) {
        return 1;
      }

      if (this.drawResult.triple === "0") {
        return this.drawResult.bs || 1;
      }

      return this.drawResult.triple || 1;
    }
  },
  data() {
    return {
      // Preset random positions for dices
      randomPositions: [
        [
          {
            top: "21%",
            left: "42%",
            transform: "rotate(45deg)"
          },
          {
            top: "32%",
            left: "28%",
            transform: "rotate(34deg)"
          },
          {
            top: "42%",
            left: "45%",
            transform: "rotate(97deg)"
          },
          {
            top: "34%",
            left: "62%",
            transform: "rotate(164deg)"
          },
          {
            top: "53%",
            left: "25%",
            transform: "rotate(68deg)"
          },
          {
            top: "60%",
            left: "48%",
            transform: "rotate(0deg)"
          }
        ],
        [
          {
            top: "24%",
            left: "36%",
            transform: "rotate(34deg)"
          },
          {
            top: "42%",
            left: "23%",
            transform: "rotate(59deg)"
          },
          {
            top: "42%",
            left: "43%",
            transform: "rotate(67deg)"
          },
          {
            top: "33%",
            left: "59%",
            transform: "rotate(80deg)"
          },
          {
            top: "61%",
            left: "39%",
            transform: "rotate(68deg)"
          },
          {
            top: "52%",
            left: "60%",
            transform: "rotate(18deg)"
          }
        ]
      ],
      isAnimationRunning: false,
      stopAnimation: false,
      displayStopAnimationSection: false
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      if (newVal) {
        this.isAnimationRunning = true;
      }
    },
    drawResult(newVal, oldVal) {
      if (newVal && this.isAnimationRunning) {
        let vm = this;

        let animationTl = new TimelineLite();
        animationTl
          // First make sure the animation section is always set to display
          .set(vm.$refs["animation-section"], {
            display: "flex",
            opacity: 1
          })
          // Set animation image display attr from none to block and opacity to 0
          // For animation image, reset the src attribute
          // to make sure image is always play for the next loop
          .set(vm.$refs["tai-xiu-animation-img"], {
            display: "block",
            opacity: 0,
            onComplete: function() {
              animationTl.set(vm.$refs["animation-result"].$el, {
                display: "none"
              });

              vm.$refs[
                "tai-xiu-animation-img"
              ].src = require("../../assets/images/common/blank.gif");
              setTimeout(() => {
                vm.$refs[
                  "tai-xiu-animation-img"
                ].src = require("../../assets/images/tai-xiu/animations/dice-drawing-no-comp-2.gif");
              }, 0);

              // vm.$nextTick(() => {
              //   vm.$refs[
              //     "tai-xiu-animation-img"
              //   ].src = require("../../assets/images/tai-xiu/animations/dice-drawing-no-comp-2.gif");
              //   console.log(vm.gameData.gCode+':tai-xiu-animation-img');
              // });
            }
          })
          // Start fade in effect
          .to(vm.$refs["tai-xiu-animation-img"], 0.25, {
            opacity: 1
          })
          // Wait for 1.5s before start fade out effect
          // Lastly, set container and image display attr to none
          .to(vm.$refs["tai-xiu-animation-img"], 0.25, {
            delay: 1.5,
            opacity: 0,
            display: "none",
            onComplete: function() {
              vm.$refs[
                "tai-xiu-animation-img"
              ].src = require("../../assets/images/common/blank.gif");
              vm.isAnimationRunning = false;
            }
          })
          // Set animation result to not display
          .set(vm.$refs["animation-result"].$el, {
            display: "none"
          });

        animationTl.restart();

        animationTl.eventCallback("onComplete", () => {
          plateTl = new TimelineLite();
          diceTl = new TimelineLite();
          let vm = this;
          // Indexes array for drawing number
          let indexes = [0, 1, 2, 3, 4, 5];

          // Generate random positions index, refer to randomPositions(2 sets of fixed position for dices)
          let randomPositionIndex = random(1);

          // Generate dice 1 random index number for getting index of array
          // Get random position index for dice 1 from indexes array
          // Then remove the selected index for preventing same index is selected
          let dice1RandomIndex = random(5);
          let randomPositionDice1Index = indexes[dice1RandomIndex];
          indexes.splice(dice1RandomIndex, 1);

          // Generate dice 2 random index number for getting index of array
          // Get random position index for dice 2 from indexes array
          // Then remove the selected index for preventing same index is selected
          let dice2RandomIndex = random(4);
          let randomPositionDice2Index = indexes[dice2RandomIndex];
          indexes.splice(dice2RandomIndex, 1);

          // Generate dice 3 random index number for getting index of array
          // Get random position index for dice 2 from indexes array
          let dice3RandomIndex = random(3);
          let randomPositionDice3Index = indexes[dice3RandomIndex];

          // Create instance for both plate and dice timeline
          this.isAnimationRunning = true;
          // console.log("ClearTaixiu1Stake");
          clearStakeRecord(this.gameData.gID);

          plateTl.clear();
          diceTl.clear();

          plateTl
            // After animation image end, set result animation to be display
            .set(this.$refs["animation-result"].$el, {
              display: "flex"
            })
            .set(vm.$refs["animation-plate"], {
              opacity: 1
            })
            // Start animation for drawing plate, by applying fade in and scalling up effect
            .fromTo(
              vm.$refs["animation-result-container"],
              0.5,
              {
                opacity: 0,
                transform: "scale(0.6)"
              },
              {
                opacity: 1,
                transform: "scale(0.8)"
              }
            )
            // Delay for 1s before fading out
            .to(vm.$refs["animation-plate"], 0.25, {
              delay: 1,
              opacity: 0
            })
            // Set banner container to be present
            .set(vm.$refs["animation-banner-container"], {
              display: "block"
            })
            // Apply fade in effect for banner
            .fromTo(
              vm.$refs["animation-banner-container"],
              0.5,
              {
                opacity: 0
              },
              {
                opacity: 1
              }
            )
            // Banner will be applied with fade out effect after 1.5s of delay
            .fromTo(
              vm.$refs["animation-section"],
              0.5,
              {
                opacity: 1
              },
              {
                opacity: 0,
                delay: 1.5
              }
            )
            // Set animation section display attr to none
            .set(vm.$refs["animation-section"], {
              display: "none"
            })
            .set(vm.$refs["animation-result"].$el, {
              display: "none"
            });

          // Dice timeline

          diceTl
            // Set first dice random position and the dice number to be display
            .set(vm.$refs["animation-tai-xiu-1"], {
              ...this.randomPositions[randomPositionIndex][
                randomPositionDice1Index
              ],
              src: require(`../../assets/images/tai-xiu/assets/dice-${this.drawResult.n1}.png`)
            })
            // Set second dice random position and the dice number to be display
            .set(vm.$refs["animation-tai-xiu-2"], {
              ...this.randomPositions[randomPositionIndex][
                randomPositionDice2Index
              ],
              src: require(`../../assets/images/tai-xiu/assets/dice-${this.drawResult.n2}.png`)
            })
            // Set third dice random position and the dice number to be display
            .set(vm.$refs["animation-tai-xiu-3"], {
              ...this.randomPositions[randomPositionIndex][
                randomPositionDice3Index
              ],
              src: require(`../../assets/images/tai-xiu/assets/dice-${this.drawResult.n3}.png`)
            })
            // Set display attr for dices from none to block
            // Set initial size for dices to be 0.8 of original size
            .set(
              [
                vm.$refs["animation-tai-xiu-1"],
                vm.$refs["animation-tai-xiu-2"],
                vm.$refs["animation-tai-xiu-3"]
              ],
              {
                display: "block"
              }
            )
            // Start fade in and scalling up effect for dices
            .to(
              [
                vm.$refs["animation-tai-xiu-1"],
                vm.$refs["animation-tai-xiu-2"],
                vm.$refs["animation-tai-xiu-3"]
              ],
              0.25,
              {
                opacity: 1
              }
            )
            // Show shaking effect
            .to(
              [
                vm.$refs["animation-tai-xiu-1"],
                vm.$refs["animation-tai-xiu-2"],
                vm.$refs["animation-tai-xiu-3"]
              ],
              0.5,
              {
                x: 2,
                y: 2,
                ease: RoughEase.ease.config({
                  strength: 8,
                  points: 50,
                  taper: "none",
                  randomize: true,
                  clamp: false
                }),
                delay: 0.5
              }
            )
            // Animation of dices to fixed banner section location
            .to(vm.$refs["animation-tai-xiu-1"], 0.25, {
              top: "42%",
              left: "26%",
              transform: "none"
            })
            .to(vm.$refs["animation-tai-xiu-2"], 0.25, {
              top: "42%",
              left: "43%",
              transform: "none"
            })
            .to(vm.$refs["animation-tai-xiu-3"], 0.25, {
              top: "42%",
              left: "60%",
              transform: "none"
            })
            // After showing result for 2s, fading out dices
            .to(
              [
                vm.$refs["animation-tai-xiu-1"],
                vm.$refs["animation-tai-xiu-2"],
                vm.$refs["animation-tai-xiu-3"]
              ],
              0.25,
              {
                opacity: 0,
                delay: 2
              }
            )
            // Set dices display attr to none
            .set(
              [
                vm.$refs["animation-tai-xiu-1"],
                vm.$refs["animation-tai-xiu-2"],
                vm.$refs["animation-tai-xiu-3"]
              ],
              {
                display: "none"
              }
            );

          // After animation end, trigger animation end event to TaiXiu
          // to turn showDrawingAnimation flag to false
          diceTl.eventCallback("onComplete", () => {
            this.isAnimationRunning = false;
            this.animationEnd();
          });

          plateTl.restart();
          diceTl.restart();
          // console.log("ClearTaixiu2Stake");
          clearStakeRecord(this.gameData.gID);
          EventBus.$emit("update-session-storage");
        });
      }
    }
  },
  mounted() {
    EventBus.$emit("update-session-storage");
  },
  methods: {
    animationEnd() {
      this.$emit("on-animation-end");
    },
    nextDrawOnClick() {
      // console.log("next draw on click");
      // this.$emit("on-animation-end");

      let vm = this;
      let stopAnimationInterval;
      let stopAnimationTimeout;
      let intervalCounter = 0;

      // Show stop animation section

      stopAnimationInterval = setInterval(() => {
        vm.$refs["animation-section"].style.display = "none";
        intervalCounter++;

        if (intervalCounter > 5) {
          plateTl.stop();
          diceTl.stop();
          clearInterval(stopAnimationInterval);
        }
      }, 100);

      stopAnimationTimeout = setTimeout(() => {
        vm.isAnimationRunning = false;
        vm.animationEnd();

        clearTimeout(stopAnimationTimeout);
      }, 3000);
    }
  }
};
</script>

<style lang="scss" scoped>
.tai-xiu-game {
  position: relative;
  background: #dac1b3;
  height: 373px;
}

.tai-xiu-animation-section {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url(../../assets/images/common/000000.png);
}

.tai-xiu-animation-section.hide {
  display: none;
}

.tai-xiu-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.tai-xiu-stop-animation-section {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.tai-xiu-stop-animation-section.show {
  display: block;
}

.tai-xiu-disallow-betting,
.tai-xiu-stop-animation {
  width: 100%;
  height: 100%;
}

.tai-xiu-animation-container {
  height: 100%;
  width: 100%;
  max-width: 320px;
  margin: 0 auto;
}

.tai-xiu-animation-result {
  display: none;
  width: 100%;
  height: 100%;
  position: relative;
}

.tai-xiu-animation-result .tai-xiu-animation-result-plate {
  width: 100%;
  height: auto;
  z-index: 99;
}

.tai-xiu-animation-result-container,
.tai-xiu-animation-banner-container {
  position: relative;
}

.tai-xiu-animation-result-container {
  z-index: 2;
}

.tai-xiu-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.tai-xiu-animation-result-dice {
  display: none;
  width: 15%;
  position: absolute;
  top: 0;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 0 4px 2px #00000044;
}

.tai-xiu-animation-result-banner-top,
.tai-xiu-animation-result-banner-sum {
  width: 85%;
  position: absolute;
  top: 15%;
}

.tai-xiu-animation-result-banner-sum {
  top: 15%;
}

.tai-xiu-animation-result-banner-sum-total {
  font-size: 24px;
  color: $tai-xiu-theme-color-6;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
}

.tai-xiu-animation-result-banner-sum-title {
  color: white;
  font-weight: bold;
}

.tai-xiu-animation-result-banner-bottom,
.tai-xiu-animation-result-banner-game {
  width: 85%;
  position: absolute;
  bottom: 13%;
}

.tai-xiu-animation-result-banner-game {
  bottom: 20%;
}

.tai-xiu-animation-result-banner-game-result {
  padding: 5px;
  background-color: white;
  color: $tai-xiu-theme-color-3;
  font-weight: bold;
  // width: 60px;
  width: 78px;
  margin: 0 5px;
  border-radius: 8px;
  text-align: center;
}

// .tai-xiu-game-animation-next-draw {
//   background-color: $tai-xiu-theme-color-13;
//   color: $tai-xiu-theme-color-5;
//   border-radius: 6px;
//   font-size: 14px;
//   margin-right: 5px;
//   padding: 4px 20px;
//   font-weight: bolder;
//   z-index: 1;
// }

.tai-xiu-game-animation-next-draw-section {
  width: 100%;
  display: block;
  height: 1px;
  clear: both;
}

.tai-xiu-animation-inner {
  position: relative;
  width: 100%;
}

.tai-xiu-animation-banner-inner {
  height: 100%;
}
</style>
